export const environment = {
  production: false,
  name: 'STAGING',
  apiUrls: {
      authApi: 'https://api-auth.hml.mydocs.com.br/api/v1',
      coreApi: 'https://api-core.hml.mydocs.com.br/api/v1',
      uploadApi: 'https://api-upload.hml.mydocs.com.br/api/v1',
      documentServer: 'http://177.84.60.56:30134',
  },
};
